import React, { Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { clearErrorAction, myOrderAction } from '../../redux/actions/orderAction';
import Loader from '../../layout/loader';
import Typography from '@material-ui/core/Typography';
import swal from 'sweetalert';
import MetaTag from '../../layout/MetaTag';
import Navbar from '../HomeScreen/Navbar';
import Footer from '../HomeScreen/bottomsection/Footer';
import './delivery.css';

function DeliveryPage() {
  const dispatch = useDispatch();

  const { error, loading, orders } = useSelector((state) => state.myOrders);
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (error) {
      swal({
        title: "Error",
        text: error,
        icon: 'error',
      });
      dispatch(clearErrorAction());
    }

    dispatch(myOrderAction());
  }, [dispatch, error]);

  return (
    <Fragment>
      <MetaTag title={`IM Online Shopping ${user.firstName} All Orders Details Page`} />
      <Navbar />
      
      {loading ? (
        <Loader />
      ) : (
        <div className="myOrdersPage">
          <div className="ordersContainer">
            <Typography variant="h4" className="ordersHeading">
              My Orders
            </Typography>
            
            {!orders || orders.length === 0 ? (
              <div className="emptyOrders">
                <p>You haven't placed any orders yet.</p>
                <Link to="/Product" className="shopNowBtn">Shop Now</Link>
              </div>
            ) : (
              <div className="ordersList">
                {orders.map((order) => (
                  <div className="orderCard" key={order._id}>
                    <div className="orderHeader">
                      <div className="headerLeft">
                        <span className="orderLabel">ORDER PLACED</span>
                        <span className="orderValue">
                          {new Date(order.createdAt).toLocaleDateString('en-IN', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}
                        </span>
                      </div>
                      
                      <div className="headerMiddle">
                        <span className="orderLabel">TOTAL</span>
                        <span className="orderValue priceValue">₹{order.totalPrice.toLocaleString('en-IN')}</span>
                      </div>
                      
                      <div className="headerId">
                        <span className="orderLabel">ORDER #</span>
                        <span className="orderValue idValue">{order._id}</span>
                      </div>
                      
                      <div className="headerStatus" style={{ display: "flex", gap: "6px", alignItems: "center", flexWrap: "wrap" }}>
                        {order.orderType && order.orderType !== 'HOME_DELIVERY' && (
                          <span style={{
                            fontSize: "11px",
                            fontWeight: "800",
                            padding: "3px 8px",
                            borderRadius: "6px",
                            background: order.orderType === 'STORE_PICKUP' ? "#eff6ff" : order.orderType === 'RESERVE_ADVANCE' ? "#fffbeb" : "#f5f3ff",
                            color: order.orderType === 'STORE_PICKUP' ? "#1d4ed8" : order.orderType === 'RESERVE_ADVANCE' ? "#92400e" : "#5b21b6",
                            border: "1px solid",
                            borderColor: order.orderType === 'STORE_PICKUP' ? "#bfdbfe" : order.orderType === 'RESERVE_ADVANCE' ? "#fde68a" : "#ddd6fe"
                          }}>
                            {order.orderType === 'STORE_PICKUP' ? `🏪 Pickup` : order.orderType === 'RESERVE_ADVANCE' ? `🔖 Advance Reservation` : `📌 Booking`}
                            {order.fulfillment?.verificationCode ? ` (${order.fulfillment.verificationCode})` : ''}
                          </span>
                        )}
                        <span className={`statusBadge ${order.orderStatus.toLowerCase()}`}>
                          {order.fulfillment?.status === 'READY_FOR_PICKUP' ? 'Ready for Pickup' : order.orderStatus}
                        </span>
                      </div>
                    </div>
                    
                    <div className="orderBody">
                      {order.orderItems.map((item, idx) => (
                        <div className="orderItemRow" key={idx}>
                          <img src={item.image} alt={item.name} className="orderItemImg" />
                          <div className="orderItemDetails">
                            <span className="orderItemName">{item.name}</span>
                            <span className="orderItemMeta">
                              Size: {item.size} | Color: {item.colour} | Qty: {item.quantity}
                            </span>
                            <span className="orderItemPrice">₹{item.price.toLocaleString('en-IN')}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                    
                    <div className="orderFooter">
                      <Link to={`/order/${order._id}`} className="viewDetailsBtn">
                        View Details
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
      
      <Footer />
    </Fragment>
  );
}

export default DeliveryPage;